module.exports = __webpack_public_path__ + "img/photo-1-1.9fb39894.jpg";